module.exports = __webpack_public_path__ + "img/clipboard.4aa686d8.svg";